import { useContext, useMemo } from 'react';
import AccountContext from 'contexts/AccountContext';
import DatasetDefinitionsContext from 'contexts/DatasetDefinitionsContext';
import useGetDatasetDefinition from 'hooks/useGetDatasetDefinition';

const DEMO_6_DRIVER_13_WEEKS_FIELDS = [
  'safetyIncidents',
  'casualMiles',
  'totalMiles',
  'driverMpg',
  'percentPodsReceived',
];

// A field has trackable progress when a targetable dataset (performance and
// driver/truck/trailer days datasets) carries its target and difference
// alongside it, which is what the progress and status cells read. Both Target
// Manager targets and ETL driver targets (e.g. McLeod driverTargets) add these
// fields.
const getFieldsWithTargetProgress = (
  dataset: FleetOps.DatasetDefinition | undefined,
): string[] => {
  if (!dataset || !dataset.isTargetable) {
    return [];
  }

  const fieldNames = new Set(dataset.fields.map((f) => f.field));
  return Array.from(fieldNames).filter(
    (field) =>
      fieldNames.has(`${field}Target`) && fieldNames.has(`${field}Difference`),
  );
};

const useGetFieldsWhichHaveTargets = ({ dataType }: { dataType: string }) => {
  const { isDemo6 } = useContext(AccountContext);
  const { isLoading } = useContext(DatasetDefinitionsContext);
  const getDatasetDefinition = useGetDatasetDefinition();

  const fields = useMemo(() => {
    if (isDemo6 && dataType === 'performanceDriver13Weeks') {
      return DEMO_6_DRIVER_13_WEEKS_FIELDS;
    }

    return getFieldsWithTargetProgress(getDatasetDefinition(dataType));
  }, [dataType, getDatasetDefinition, isDemo6]);

  return {
    fields,
    isLoading,
  };
};

export default useGetFieldsWhichHaveTargets;
